// Supplier Table
export const TABLE_SECTION_TEST_ID = 'supplier-table-section';
export const TABLE_CAPTION_TEST_ID = 'supplier-table-caption';
export const TABLE_PAPER_TEST_ID = 'supplier-table-paper';
export const TABLE_TOP_TOOLBAR_TEST_ID = 'supplier-table-top-toolbar';
export const TABLE_BOTTOM_TOOLBAR_TEST_ID = 'supplier-table-bottom-toolbar';
export const ACTION_ADD_SUPPLIER_TEST_ID = 'supplier-table-custom-action-add-supplier';
export const ACTION_UPLOAD_SUPPLIERS_TEST_ID = 'supplier-table-custom-action-upload-suppliers';
export const ACTION_RESET_FILTERS = 'supplier-table-custom-action-reset-filter';
export const ACTION_INCLUDE_DEACTIVATED = 'supplier-table-custom-action-include-deactivated';
export const FULL_TEXT_SEARCH_TEST_ID = 'supplier-table-top-toolbar-full-text-search';
export const TABLE_BODY_TEST_ID = 'supplier-table-body';

// supplier-table-row-0
// supplier-table-row-123 (businessId)

export const SM_ADMIN_ROLE = 'R_SM_SUPPLIER_ADMIN';
export const SM_MANAGER_ROLE = 'R_SM_SUPPLIER_MANAGER';
export const SM_READER_ROLE = 'R_SM_SUPPLIER_READER';

export const TABLE_ROW_TEST_ID = 'supplier-table-row';
export const TABLE_COLUMN_TEST_ID = 'supplier-table-column';
export const TABLE_CELL_TEST_ID = 'supplier-table-cell';
export const TABLE_HEADER_TEST_ID = 'supplier-table-header';

// Supplier Form
export const ADD_SUPPLIER_FORM_TEST_ID = 'add-supplier-form';
export const EDIT_SUPPLIER_FORM_TEST_ID = 'edit-supplier-form';

// suplier-contact-1 (index +1)
export const SUPPLIER_FORM_CONTACT_TEST_ID = 'supplier-contact';

export const INACTIVITY_TIMEOUT = 30 * 60 * 1000;
export const PROMPT_BEFORE_IDLE_TIMEOUT = 15 * 60 * 1000;

export const withTestId = (id: string) => {
  return { 'data-testid': id };
};


export function returnCurrentEnv(): 'prd' | 'uat' | 'tat' | 'dev' {
  if (import.meta.env.VITE_APP_ENVIRONMENT === 'prd') {
    return 'prd';
  }
  if (import.meta.env.VITE_APP_ENVIRONMENT === 'tat') {
    return 'tat';
  }
  if (import.meta.env.VITE_APP_ENVIRONMENT === 'uat') {
    return 'uat';
  }
  return 'dev';
}
